import {configureStore, createSlice} from '@reduxjs/toolkit';
import CryptoJS from 'crypto-js';

// Define the initial state
const initialState = {
  user: null,
  loginState: false,
  cache_pool: {},
  cache_hit: null,
  spin: false,
};

// Create a slice for the store
const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    storeSpin(state, action) {
      state.spin = action.payload;
    },
    storeLogin(state, action) {
      state.user = action.payload;
      state.loginState = true;
    },
    storeSetUser(state, action) {
      state.user = action.payload;
    },
    storeLogout(state) {
      state.loginState = false;
      state.user = null;
    },
    storeSetCache(state, action) {
      const cache = action.payload;
      cache.md5 = CryptoJS.MD5(cache.key).toString();
      cache.time = Date.now();
      let cache_key = cache.md5[0];
      if (!state.cache_pool[cache_key]) {
        state.cache_pool[cache_key] = {num: 0, max: 10, cache: {}};
      }
      let cache_block = state.cache_pool[cache_key];
      if (cache_block.cache[cache.md5]) {
        cache_block.cache[cache.md5] = cache;
      } else {
        if (cache_block.num >= cache_block.max) {
          let swap, time = Date.now();
          for (let name in cache_block.cache) {
            if (cache_block.cache[name].time < time) {
              time = Math.min(time, cache_block.cache[name].time);
              swap = name;
            }
          }
          delete cache_block.cache[swap];
          cache_block.num--;
        }
        cache_block.cache[cache.md5] = cache;
        cache_block.num++;
      }
    },
    storeGetCache(state, action) {
      const key = action.payload;
      let md5 = CryptoJS.MD5(key).toString();
      let cache_key = md5[0];
      if (!state.cache_pool[cache_key]) {
        state.cache_hit = null;
        return;
      }
      let cache_block = state.cache_pool[cache_key];
      if (cache_block?.cache[md5]) {
        cache_block.cache[md5].time = Date.now();
        state.cache_hit = cache_block.cache[md5];
      } else {
        state.cache_hit = null;
      }
    },
  },
});

// Destructure and export the actions
export const {
  storeSpin,
  storeLogin,
  storeSetUser,
  storeLogout,
  storeSetCache,
  storeGetCache
} = storeSlice.actions;

// Create the store using configureStore
const store = configureStore({
  reducer: {
    store: storeSlice.reducer,
  },
  // Add any middleware here
});

export default store;